"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _commons = require("@focaltec-suite/commons");
var _core = require("@focaltec-suite/core");
var _reactRouterDom = require("react-router-dom");
var _api = require("@focaltec-suite/api");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var NotificationsList = (0, _material.styled)(_material.List)(function (_ref) {
  var theme = _ref.theme;
  return {
    minWidth: theme.spacing(50),
    maxWidth: theme.spacing(50)
  };
});
var NotificationsListItemIcon = (0, _material.styled)(_material.ListItemIcon)(function (_ref2) {
  var theme = _ref2.theme;
  return _defineProperty({
    minWidth: theme.spacing(5)
  }, theme.breakpoints.down('sm'), {
    minWidth: theme.spacing(3)
  });
});
var NotificationsListSubheaderContainer = (0, _material.styled)(_material.Grid)(function (_ref4) {
  var theme = _ref4.theme;
  return {
    '& > .MuiGrid-item': {
      paddingTop: '0 !important',
      lineHeight: '1px'
    }
  };
});
function NotificationsPopup(_ref5) {
  var tenantId = _ref5.tenantId,
    _ref5$page = _ref5.page,
    page = _ref5$page === void 0 ? 5 : _ref5$page,
    anchorRef = _ref5.anchorRef,
    onMarkedAllRead = _ref5.onMarkedAllRead,
    onView = _ref5.onView,
    onClose = _ref5.onClose,
    updateUnread = _ref5.updateUnread;
  var context = (0, _react.useContext)(_core.AppContext);
  var access = context.access;
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    notifications = _useState2[0],
    setNotifications = _useState2[1];
  var handleListKeyDown = (0, _react.useCallback)(function (event) {
    if (event.key === 'Tab' || event.key === 'Escape') {
      event.preventDefault();
      onClose();
    }
  }, [onClose]);
  var retrievePromise = (0, _react.useCallback)(function () {
    return (0, _api.listNotifications)({
      tenantId: tenantId,
      read: false,
      page: page
    }, {
      access: access
    });
  }, [tenantId, page, access]);
  var setData = (0, _react.useCallback)(function (response) {
    setNotifications(response.items);
    updateUnread(response.unread);
  }, [updateUnread]);
  return /*#__PURE__*/_react["default"].createElement(_commons.PopperMenu, {
    placement: "bottom-start",
    anchorRef: anchorRef,
    onClose: onClose
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    sx: function sx(theme) {
      return {
        minHeight: theme.spacing(4),
        minWidth: theme.spacing(50),
        paddingTop: theme.spacing(2)
      };
    }
  }, /*#__PURE__*/_react["default"].createElement(_commons.Retrievable, {
    getPromise: retrievePromise,
    setData: setData,
    builder: function builder() {
      return /*#__PURE__*/_react["default"].createElement(NotificationsList, {
        subheader: /*#__PURE__*/_react["default"].createElement(_material.ListSubheader, null, /*#__PURE__*/_react["default"].createElement(NotificationsListSubheaderContainer, {
          container: true,
          justifyContent: "space-between",
          alignItems: "center",
          rowSpacing: 1
        }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
          item: true,
          xs: true
        }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
          variant: "body1",
          color: "textSecondary"
        }, (0, _core.translate)('notifications.title'))), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
          item: true,
          xs: "auto"
        }, /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
          color: "primary",
          size: "small",
          onClick: onMarkedAllRead,
          disabled: notifications.length === 0,
          title: (0, _core.translate)('notifications.mark_as_read')
        }, /*#__PURE__*/_react["default"].createElement(_commons.MarkReadIcon, null))), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
          item: true,
          xs: "auto"
        }, /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
          color: "default",
          size: "small",
          onClick: onClose,
          component: _reactRouterDom.Link,
          to: context.fixPath('/notifications'),
          title: (0, _core.translate)('notifications.see_all')
        }, /*#__PURE__*/_react["default"].createElement(_commons.ExternalLinkIcon, null))), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
          item: true,
          xs: 12
        }, /*#__PURE__*/_react["default"].createElement(_material.Divider, {
          sx: function sx(theme) {
            return {
              pt: theme.spacing(0.5),
              mt: theme.spacing(0.5),
              mx: theme.spacing(-2),
              mb: theme.spacing(1)
            };
          }
        })))),
        onKeyDown: handleListKeyDown
      }, notifications.map(function (notification) {
        return /*#__PURE__*/_react["default"].createElement(_material.ListItemButton, {
          key: notification.id,
          onClick: function onClick() {
            return onView(notification);
          },
          dense: true
        }, /*#__PURE__*/_react["default"].createElement(NotificationsListItemIcon, null, /*#__PURE__*/_react["default"].createElement(_material.Badge, {
          color: "success",
          variant: "dot",
          invisible: notification.read
        }, /*#__PURE__*/_react["default"].createElement(_commons.NotificationsIcon, null))), /*#__PURE__*/_react["default"].createElement(_material.ListItemText, {
          primary: notification.subject,
          secondary: notification.text,
          secondaryTypographyProps: {
            variant: 'caption',
            noWrap: true
          }
        }));
      }), notifications.length === 0 && /*#__PURE__*/_react["default"].createElement(_material.Typography, {
        variant: "body2",
        component: "h6",
        color: "textSecondary",
        textAlign: "center",
        sx: {
          pt: 2,
          pb: 1
        }
      }, (0, _core.translate)('notifications.empty_popup')));
    }
  }))));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(NotificationsPopup);